import { useProductSearchFilterParamsStore } from "@/stores/productSearch/productSearchFilterParamsStore";
import { useProductSearchPaginationStore } from "@/stores/productSearch/productSearchPaginationStore";
import { useProductSearchActiveBusinessUnit } from "@/stores/productSearch/productSearchActiveBusinessUnit";
import { useCustomerSearchFilterParamsStore } from "@/stores/customerSearch/customerSearchFilterParamsStore";
import { useOutboxFilterParamsStore } from "@/stores/outbox/outboxFilterParamsStore";

export const useClearStorageSession = () => {
    const filterParamsStore = useProductSearchFilterParamsStore();
    const paginationStore = useProductSearchPaginationStore();
    const activeBusinessUnitStore = useProductSearchActiveBusinessUnit();
    const customerSearchFilterParamsStore = useCustomerSearchFilterParamsStore();
    const outboxFilterParamsStore = useOutboxFilterParamsStore();

    const clear = async () => {
        await filterParamsStore.reset();
        await paginationStore.reset();
        activeBusinessUnitStore.reset();
        await customerSearchFilterParamsStore.reset();
        await outboxFilterParamsStore.reset();
    };

    return { clear };
};
